import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { getJSON } from '../../shared/util';

export function* setPage({ payload }) {
    yield put({
        type: 'articles:update',
        payload: {
            page: payload.page,
        },
    });

    const url = new URL(window.location);
    url.searchParams.set('page', payload.page);
    history.pushState({}, '', url);
}

export function* getPage({ payload }) {
    let [articles, pages, params] = yield all([
        select(state => state.articles && state.articles.list),
        select(state => state.articles && state.articles.pages),
        select(state => state.articles && state.articles.params),
    ]);

    if (
        payload.page >= 1
        &&
        payload.page <= pages
        &&
        !articles[payload.page]
    ) {
        articles = yield call(get, articles, payload.page, params);

        yield put({
            type: 'articles:update',
            payload: {
                list: articles,
            },
        });
    }
}

function* get(articles, page, params) {
    params = {
        ...params,
        ...{
            page: page,
        },
    };

    const new_articles = yield call(getJSON, '/api/content/articles/get', params);

    articles[page] = new_articles.data;

    articles = Object.keys(articles).sort().reduce((obj, key) => {
        obj[key] = articles[key];
        return obj;
    }, {});

    return articles;
}

export function* root() {
    yield all([
        takeEvery('articles:get-page', getPage),
        takeEvery('articles:set-page', setPage),
    ]);
}
